function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 0h38a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#f0e2db",
  d: "M32.391 27.684l-2.372-11.062A3.324 3.324 0 0 0 26.759 14h-1.108a1.109 1.109 0 0 0-1 .619 7.855 7.855 0 0 1-1.5 2.08l-4.911 4.912a1.11 1.11 0 0 1-1.563 0L11.76 16.7a7.833 7.833 0 0 1-1.5-2.069 1.109 1.109 0 0 0-1-.619H8.158a3.324 3.324 0 0 0-3.248 2.622L2.537 27.7a3.321 3.321 0 0 0 3.259 4h23.347a3.321 3.321 0 0 0 3.248-4.016z",
  transform: "translate(10 9.5) translate(-2.465 -0.7)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M24.281 5.011A10.27 10.27 0 0 0 7.819 16.87a10.023 10.023 0 0 0 1.918 2.655l4.911 7.912a3.331 3.331 0 0 0 4.711 0l4.911-7.912a10.056 10.056 0 0 0 1.918-2.655 10.184 10.184 0 0 0-1.907-11.859z",
  transform: "translate(10 9.5) translate(-2.005 -1.977)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d4d4f",
  d: "M20.175 8.145a5.162 5.162 0 1 0 1.519 3.662 5.127 5.127 0 0 0-1.519-3.662z",
  transform: "translate(10 9.5) translate(-1.502 -1.482)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcab2",
  d: "M15.238 7.3a2.277 2.277 0 1 0 .67 1.615 2.262 2.262 0 0 0-.67-1.615z",
  transform: "translate(10 9.5) translate(1.391 1.405)"
}));

function SvgColorIconsRegions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconsRegions);
export default __webpack_public_path__ + "static/media/color-icons_regions.2cd193db.svg";
export { ForwardRef as ReactComponent };